export default __webpack_public_path__ + "static/media/idle_vehicle.59183a79.png";